export default __webpack_public_path__ + "static/aboutHeroSmall-82a8f4fa0f181679b2e433b39e1bbb36.svg";